import {get} from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {storeChatGroups} from '../../../../../../service/store-management'

const model = createProjectModel({
    namespace: 'communityModal',

    state: {
        tableData: {},
    },

    effects: {
        // 门店社群列表-分页
        *storeChatGroups({payload}, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...payload?.params,
            }

            const res = yield call(storeChatGroups, {params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
        },
    },
})

export default model
